var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"box"},[_c('div',{staticClass:"auto-text",class:_vm.overflow,style:(_vm.styles)},[_vm._t("default",[_vm._v(_vm._s(_vm.text))])],2)])}
var staticRenderFns = []

export { render, staticRenderFns }